<template>
  <UPopover mode="hover" v-if="totalItems > 0">
    <UChip :text="totalItems" size="3xl" class="h-[12px] min-w-[12px] text-[12px]" :ui="{ base: 'px-1 py-2' }">
      <UButton color="neutral" variant="soft" icon="material-symbols:shopping-cart-rounded"
        class="cursor-pointer rounded-full text-xl" size="xl" @click="goToCart()" />
    </UChip>
    <template #content>
      <section class="p-3 md:p-6 flex flex-col max-w-lg w-72" v-if="cart?.length">
        <div class="flex justify-between gap-3 mb-3 font-bold">
          <p>{{ totalItems }} {{ totalItems === 1 ? 'Item' : 'Items' }}</p>
        </div>

        <hr class="opacity-20 mb-2" />

        <ul class="mb-3 flex gap-2 flex-col max-h-64 overflow-y-auto pr-1">
          <li v-for="item in cart" :key="item.id"
            class="flex justify-between items-start gap-2 border-b pb-3 border-zinc-300">
            <p class="text-sm line-clamp-2">{{ item.name }}</p>
            <p class="font-bold whitespace-nowrap">x{{ item.quantity }}</p>
          </li>
        </ul>

        <div class="text-right mt-2">
          <p class="font-bold text-lg">Total: £{{ convertPenceToPounds(cartGrandTotal) }}</p>
          <p class="text-xs text-gray-500">Includes VAT</p>
        </div>

        <div class="flex gap-2 flex-wrap justify-end mt-6">
          <UButton @click="goToCart()" icon="mdi-shopping-cart" class="flex-1 cursor-pointer" variant="soft">
            View Cart
          </UButton>
          <UButton @click="goToCheckout()" icon="mdi-credit-card" class="flex-1 cursor-pointer">
            Checkout
          </UButton>
        </div>
      </section>
    </template>
  </UPopover>
</template>

<script setup lang="ts">
// Swapped `totalPrice` for `cartGrandTotal`
const { cart, goToCart, totalItems, cartGrandTotal, goToCheckout } = useCart()
</script>

<style scoped></style>
